import { Role } from './role.enum.js';
/**
 * Map from backend role values (`ROLE_*`) to Keycloak realm role names
 * (`THERAME_*`).
 *
 * The two namespaces used to be a mechanical prefix swap, but TM-9323 renamed
 * `ROLE_DOCTOR` → `ROLE_THERAPIST` while the realm role stays
 * `THERAME_DOCTOR` (renaming realm roles is a prod Keycloak data migration
 * with no domain benefit). Never derive one name from the other via string
 * replace — always go through this map.
 */
const KEYCLOAK_REALM_ROLE_BY_ROLE = {
    [Role.SUPERADMIN]: 'THERAME_SUPERADMIN',
    [Role.ADMIN]: 'THERAME_ADMIN',
    [Role.THERAPIST]: 'THERAME_DOCTOR',
    [Role.MANAGEMENT]: 'THERAME_MANAGEMENT',
    [Role.PATIENT]: 'THERAME_PATIENT',
    [Role.PREVENTION]: 'THERAME_PREVENTION',
    [Role.TRANSMISSION_OPERATOR]: 'THERAME_TRANSMISSION_OPERATOR',
};
/**
 * The roles that belong to no office, the only ones an Account carries as a
 * realm role (#1823). Every other role belongs to a Person in one office and is
 * read from that Person, never from the token.
 */
export const ACCOUNT_REALM_ROLES = [Role.SUPERADMIN, Role.TRANSMISSION_OPERATOR];
export function isAccountRealmRole(role) {
    return ACCOUNT_REALM_ROLES.includes(role);
}
export function toKeycloakRealmRole(role) {
    return KEYCLOAK_REALM_ROLE_BY_ROLE[role];
}
//# sourceMappingURL=keycloak-realm-role.map.js.map